import { postWithFullResponse } from '@citrite/http';
import { UserAccountData } from '@citrite/workspace-ui-platform';

// For on-prem, the getUserDetails endpoint has been made available to support the entraID auth flow.
// Until now we have been using the getUserName endpoint to "cook" user details object to mimic the cloud flow.
// We need to continue using the getUserName endpoint and only extract the upn from the UserDetails to avoid regressions.
// We can probably REFACTOR this code once we have a more bandwidth.

export async function getUpnFromOnPremUserDetails(getUserDetailsURL: string) {
	try {
		if (!getUserDetailsURL) {
			return { upn: '' };
		}
		const resp = await postWithFullResponse<UserAccountData>(getUserDetailsURL, null, {});
		return { upn: resp?.data?.upn ?? '' };
	} catch (e) {
		return { upn: '' };
	}
}
